import React, { useContext } from "react";
import CustomStyle from "./CustomStyle";
import CustomItem from "./CustomItem";
import { useLocation } from "react-router-dom";
import TailoringContext from "../../context/TailoringContext";
import useTailoring from "../../hooks/useTailoring";
import { useFormik } from "formik";
import { UserContext } from "../../context/userContext";

const CustomOrderSummary = () => {
  const location = useLocation();
  const { customOrderRes } = useContext(TailoringContext);
  console.log(customOrderRes);


  let orderImage = location.state?.src;
  let styleName = location.state?.stylename;
  let amount = location.state?.price;
  let description = location.state?.description;
  let style_quantity = location.state?.style_quantity;
  let uniqueId = location.state?.uniqueId
  let duration = location.state?.duration;



  return (
    <>
      <div className="col-12 product form_div">
        <div className="order_details">
          <div>
            <CustomStyle {...{ orderImage }} />
          </div>
          <div>
            <CustomItem
              {...{ styleName, amount, description, style_quantity, duration, uniqueId }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomOrderSummary;
